import React from 'react';
import PropTypes from 'prop-types';
import MoneyService from "../services/moneyService";

function WBMFormatMoney(props) {
    let { amount, isFancy, large, useCurrencySign, targetAmount, className, ...rest } = props;

    let amt = MoneyService.explodeMoney(amount);

    let style = getAmountStyle(amount, targetAmount); 

    let innerContent = !isFancy ?
        `${useCurrencySign ? "$" : ""}${amt[0]}${MoneyService.addCommas(amt[1])}.${amt[2]}` :
        <>
            <span className="superscript">{amt[0]}$</span>
            {MoneyService.addCommas(amt[1])}
            <span className="superscript">{amt[2]}</span>
        </>;

    return (
        <span
            className={`${style ? style : ""} ${className}`}
            {...rest}
        >
            {large ?
                <h3>{innerContent}</h3> :
                innerContent
            }
        </span>
    );
}



function getAmountStyle(amount, targetAmount) {
    if (amount > 0 && amount < targetAmount) {
        return "text-danger";
    } else if (amount > 0 && amount >= targetAmount) {
        return "text-success";
    } else {
        //no style
        return null;
    }
}

WBMFormatMoney.propTypes = {
    isFancy: PropTypes.bool,
    amount: PropTypes.number.isRequired,
    className: PropTypes.string,
    targetAmount: PropTypes.number,
    large: PropTypes.bool,
    useCurrencySign: PropTypes.bool
};

WBMFormatMoney.defaultProps = {
    className: ""
};

export default WBMFormatMoney;
